export default __webpack_public_path__ + "aad65d0e2f7ee0332d414cd9c2e8599f.png";